import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';


const FacultyPayment = () => {

    const [faculty, setFaculty] = useState([])
    const [uid, setUid] = useState([])
    const [cid, setCid] = useState("")
    const [error, setError] = useState({})
    const [confirmationVisibleMap, setConfirmationVisibleMap] = useState({});
    const [checked, setChecked] = React.useState([true, false]);
    const [value, setValue] = useState({
        fromdate: '',
        todate: '',
        faculty: '',
    })

    //==============Validation

    const validateForm = () => {
        let isValid = true
        const newErrors = {}

        if (!value.fromdate) {
            isValid = false;
            newErrors.fromdate = "Date is Required"

        }

        if (!value.todate) {
            isValid = false;
            newErrors.todate = "Date is Required"
        }

        if (!value.faculty) {
            isValid = false;
            newErrors.faculty = "Data is Required"
        }



        setError(newErrors)
        return isValid
    }

    async function getFacultySalaryReport() {
        try {
            const response = await axios.get(`${BASE_URL}/getfaculty`, {
                headers: {
                    "Content-Type": "application/json",
                }
            });

            setFaculty(response.data);

        } catch (error) {
            console.error("Error fetching faculty salary report:", error);

        }
    }

    useEffect(() => {
        getFacultySalaryReport();
    }, []);


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))
    }


    return (
        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div className="main-panel">

                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin">
                            <div class="d-flex">

                                <div className='px-2 mx-2'><Link to="/feesreport"><h4>Cheque/PDC and Receipts</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/feesdetails"><h4>Fees Details</h4></Link></div>
                                <div className='px-2 mx-2'><Link to="/facultypayment"><h4>Faculty Payment Detail Report</h4></Link></div>
                            </div>
                            <div className="card">
                                <div className='container-fluid'>
                                    <div className='row d-flex justify-content-between'>

                                        <div className='col-lg-12'>
                                            <div className='row justify-content-center' > 
                                                <div className='p-3' style={{ width: "100%" }}>
                                                    <form class="form-sample py-3" >
                                                        <div class="row">

                                                            <div className="form-group col-lg-3">
                                                                <lable for="exampleInputUsername1">From Date<span className="text-danger">*</span></lable>
                                                                <input type="date" class="form-control" id="exampleInputUsername1" value={value.fromdate}
                                                                    name='fromdate' onChange={onhandleChange} />

                                                                {<span className='text-danger'> {error.fromdate} </span>}
                                                            </div>

                                                            <div class="form-group col-lg-3">
                                                                <lable for="exampleInputUsername1">To Date<span className="text-danger">*</span></lable>
                                                                <input type="date" class="form-control" id="exampleInputUsername1" value={value.todate}
                                                                    name='todate' onChange={onhandleChange} />

                                                                {<span className='text-danger'> {error.todate} </span>}
                                                            </div>

                                                            <div class="form-group col-lg-3">
                                                                <lable for="exampleFormControlSelect1">Select Faculty<span className="text-danger">*</span></lable>
                                                                <select class="form-control" id="exampleFormControlSelect1"
                                                                    value={value.faculty} name="faculty"
                                                                    onChange={onhandleChange}>
                                                                    <option>--Faculty Name--</option>
                                                                    {faculty.map((item, index) => (
                                                                        <option key={index} value={item.Faculty_Id}>{item.Faculty_Name}</option>
                                                                    ))}
                                                                    <option></option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className='row p-2 gap-2'>
                                                            <button className='mr-2 btn btn-primary'>Show</button>
                                                        </div>


                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default FacultyPayment